import {
  apiRequest,
  daftarpegawaiperperioderevisikeuangan,
  kenaikanpangkaInactive,
  revisiexport,
  inactiveEmployee,
} from "../../../../../services/adapters/kepegawaian/revisikeuanganService";

class DataTableRepository {
  fetchRowTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      daftarpegawaiperperioderevisikeuangan,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  // fetchInactive = async (query) => {
  //     return await apiRequest("post", kenaikanpangkaInactive, {
  //         body: query
  //     }, true)
  // }
  fetchRevisiExport = async (query) => {
    return await apiRequest(
      "get",
      revisiexport,
      {
        params: query,
      },
      true
    );
  };

  fetchInactiveEmployee = async (query) => {
    return await apiRequest(
      "post",
      inactiveEmployee,
      {
        body: query,
      },
      true
    );
  };
}

export default DataTableRepository;
